/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sessions_NoteInputs */

const th_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เซสชันมีอายุ 30 วัน หากพบรายการที่ไม่รู้จัก ให้ออกจากระบบ`)
};

const en_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions last 30 days. Sign out anything you don't recognise.`)
};

const ja_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セッションは30日間有効です。心当たりのない端末はログアウトしてください。`)
};

const zh_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会话保留 30 天。任何你不认识的都请登出。`)
};

const es_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las sesiones duran 30 días. Cierra cualquiera que no reconozcas.`)
};

const pt_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As sessões duram 30 dias. Encerre qualquer uma que você não reconheça.`)
};

const id_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi bertahan 30 hari. Keluarkan apa pun yang tidak Anda kenali.`)
};

const fr_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les sessions durent 30 jours. Déconnectez tout ce que vous ne reconnaissez pas.`)
};

const tl_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tumatagal nang 30 araw ang mga sesyon. I-sign out ang anumang hindi mo nakikilala.`)
};

const vi_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên kéo dài 30 ngày. Hãy đăng xuất bất kỳ mục nào bạn không nhận ra.`)
};

const ko_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세션은 30일 동안 유지됩니다. 알아볼 수 없는 것은 로그아웃하세요.`)
};

const de_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungen halten 30 Tage. Melde alles ab, was du nicht wiedererkennst.`)
};

const ru_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сессии живут 30 дней. Выйдите везде, где не узнаёте устройство.`)
};

const tr_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturumlar 30 gün sürer. Tanımadığınız her şeyi kapatın.`)
};

const it_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sessioni durano 30 giorni. Disconnetti tutto ciò che non riconosci.`)
};

const pl_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesje trwają 30 dni. Wyloguj wszystko, czego nie rozpoznajesz.`)
};

const uk_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сесії тривають 30 днів. Вийдіть усюди, де не впізнаєте пристрій.`)
};

const hi_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्र 30 दिन चलते हैं। जिसे आप न पहचानें, उसे साइन आउट कर दें।`)
};

const ar_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدوم الجلسات 30 يومًا. أخرج من كل ما لا تعرفه.`)
};

const ms_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi bertahan 30 hari. Log keluar apa sahaja yang anda tidak cam.`)
};

const bn_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সেশন ৩০ দিন থাকে। যা চিনতে পারছেন না তা সাইন আউট করে দিন।`)
};

const zh_tw2_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作階段會保留 30 天。任何你不認得的都請登出。`)
};

const zh_hk2_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作階段會保留 30 天。任何你不認得的都請登出。`)
};

const ur_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سیشن 30 دن رہتے ہیں۔ جو پہچان نہ سکیں اسے سائن آؤٹ کر دیں۔`)
};

const fa_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشست‌ها ۳۰ روز می‌مانند. هرچه را نمی‌شناسید خارج کنید.`)
};

const sw_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vipindi hudumu siku 30. Toa chochote usichokitambua.`)
};

const nl_sessions_note = /** @type {(inputs: Sessions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessies blijven 30 dagen geldig. Log alles uit wat je niet herkent.`)
};

/**
* | output |
* | --- |
* | "Sessions last 30 days. Sign out anything you don't recognise." |
*
* @param {Sessions_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sessions_note = /** @type {((inputs?: Sessions_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessions_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sessions_note(inputs)
	if (locale === "ja") return ja_sessions_note(inputs)
	if (locale === "zh") return zh_sessions_note(inputs)
	if (locale === "es") return es_sessions_note(inputs)
	if (locale === "pt") return pt_sessions_note(inputs)
	if (locale === "id") return id_sessions_note(inputs)
	if (locale === "fr") return fr_sessions_note(inputs)
	if (locale === "tl") return tl_sessions_note(inputs)
	if (locale === "vi") return vi_sessions_note(inputs)
	if (locale === "ko") return ko_sessions_note(inputs)
	if (locale === "de") return de_sessions_note(inputs)
	if (locale === "ru") return ru_sessions_note(inputs)
	if (locale === "tr") return tr_sessions_note(inputs)
	if (locale === "it") return it_sessions_note(inputs)
	if (locale === "pl") return pl_sessions_note(inputs)
	if (locale === "uk") return uk_sessions_note(inputs)
	if (locale === "hi") return hi_sessions_note(inputs)
	if (locale === "ar") return ar_sessions_note(inputs)
	if (locale === "ms") return ms_sessions_note(inputs)
	if (locale === "bn") return bn_sessions_note(inputs)
	if (locale === "zh-TW") return zh_tw2_sessions_note(inputs)
	if (locale === "zh-HK") return zh_hk2_sessions_note(inputs)
	if (locale === "ur") return ur_sessions_note(inputs)
	if (locale === "fa") return fa_sessions_note(inputs)
	if (locale === "sw") return sw_sessions_note(inputs)
	if (locale === "nl") return nl_sessions_note(inputs)
	return en_sessions_note(inputs)
});